import React from 'react'
import { Button, Container, Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { FaBars, FaUser, FaUserCircle } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import { LinkContainer } from "react-router-bootstrap"
import { Link, useNavigate } from 'react-router-dom'
import headerLogo from "../assets/logo/legal-infosolutions-logo.svg"
import "../assets/styles/index.css"
import { logout } from '../slices/authSlice'

const Header = ({ onSidebarToggle }) => {
    const { userInfo } = useSelector((state) => state.auth)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const logoutHandler = async () => {
        try {
            dispatch(logout())
            navigate('/login')
        } catch (err) {
            console.log(err)
        }
    }

    const username = userInfo && userInfo[2]?.InfoField
    const empCode = userInfo && userInfo[1]?.InfoField


    return (
        <header>
            <Navbar className="modern-navbar" variant="dark" expand="lg" collapseOnSelect>
                <Container fluid className="px-3">
                    {userInfo ? (
                        <>
                            <Button onClick={onSidebarToggle} className="sidebar-toggle">
                                <FaBars className="white-icon" />
                            </Button>
                        </>
                    ) : (
                        <div className="sidebar-spacer"></div>
                    )}

                    <Navbar.Brand href="/" className='brand-logo'> 
                        <img
                            alt="Legal Infosolutions"
                            src={headerLogo}
                            className="navbar-logo"
                        />
                        <span className="brand-text d-none d-lg-inline">Legal Infosolutions</span>
                    </Navbar.Brand>
                    
                    <Navbar.Toggle aria-controls="basic-navbar-nav" className='navbar-toggler-custom'/>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto align-items-center">
                            {username ? (
                                <>
                                    <NavDropdown
                                        title={
                                            <div className="d-flex align-items-center profile-dropdown-trigger">
                                                <div className="profile-icon-container">
                                                    <FaUserCircle className="profile-icon-main" />
                                                </div>
                                                <div className="d-none d-md-flex flex-column profile-info ms-2">
                                                    <span className="profile-name">{username}</span>
                                                    <span className="profile-code">{empCode}</span>
                                                </div>
                                            </div>
                                        }
                                        id="username"
                                        align="end"
                                        className="profile-dropdown-menu"
                                    >
                                        <LinkContainer to="/profile">
                                            <NavDropdown.Item className="dropdown-item-custom">
                                                <FaUser className="me-2" />
                                                Profile
                                            </NavDropdown.Item>
                                        </LinkContainer>
                                        <NavDropdown.Item onClick={logoutHandler} className="dropdown-item-custom">
                                            Logout
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </>
                            ) : (
                                <Nav.Link as={Link} to="/login" className='text-light'>
                                    <FaUser /> Log In
                                </Nav.Link>
                            )}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            {/* {username && <Subheader />}  */}
        </header>
    )
}

export default Header
